<template>
  <div>
    <div v-if="!loading">
      <form
        id="carForm"
        ref="carForm"
        class=""
        autocomplete="off"
        @submit.prevent="onSubmitCarForm"
      >
        <div class="form-block">
          <h2>Seller Info</h2>
          <fieldset class="form-group" v-if="formData['type'] != 'sellItForMe'">
            <label for="sellerType">Dealer or private party?</label>
            <div class="custom-radio-container">
              <div class="form-check">
                <input
                  id="dealer-yes"
                  class="form-check-input"
                  type="radio"
                  value="Dealer"
                  required
                  :name="fields.sellerType"
                  :checked="isDealer"
                  @input="onChangeSellerType"
                  :disabled="isDisabled"
                />
                <label class="form-check-label" for="dealer-yes">Dealer</label>
              </div>
              <div class="form-check">
                <input
                  id="dealer-no"
                  class="form-check-input"
                  type="radio"
                  value="Private party"
                  :name="fields.sellerType"
                  :checked="!isDealer"
                  required
                  @input="onChangeSellerType"
                  :disabled="isDisabled"
                />
                <label class="form-check-label" for="dealer-no"
                  >Private party</label
                >
              </div>
            </div>
          </fieldset>

          <fieldset v-if="isDealer" class="form-group ">
            <label for="otherItemsIncludedInSale"
              >Are there any additional fees the buyer will have to pay?</label
            >
            <input
              id="otherItemsIncludedInSale"
              class="form-control"
              type="text"
              v-model="formData[fields.additionalFees]"
              :name="fields.additionalFees"
              :disabled="isDisabled"
            />
          </fieldset>
          <div v-if="isDealer" class="d-flex">
            <fieldset class="form-group ">
              <label for="dealership_name">Dealership name</label>
              <input
                id="dealership_name"
                class="form-control"
                type="text"
                required
                v-model="formData[fields.dealershipName]"
                :name="fields.dealershipName"
                :disabled="isDisabled"
              />
            </fieldset>
            <fieldset class="form-group">
              <label for="dealership_website">Dealership website</label>
              <input
                id="dealership_website"
                class="form-control"
                type="text"
                pattern="https:\/\/.+"
                title="Please type valid link. Start with https://"
                v-model="formData[fields.dealershipWebsite]"
                :name="fields.dealershipWebsite"
                :disabled="isDisabled"
              />
            </fieldset>
          </div>
          <div class="d-flex">
            <fieldset class="form-group">
              <label for="name">First name<sup>*</sup></label>
              <input
                class="form-control w-100"
                type="text"
                id="firstName"
                v-model="formData.firstName"
                value=""
                required
                name="firstName"
              />
            </fieldset>
            <fieldset class="form-group">
              <label for="name">Last name<sup>*</sup></label>
              <input
                class="form-control w-100"
                type="text"
                id="lastName"
                v-model="formData.lastName"
                value=""
                required
                name="lastName"
              />
            </fieldset>
            <!-- <div class="col-12">
            <div class="row"> -->
              
            <!-- </div>
            </div> -->
          </div>
          <div class="d-flex"> 
            <fieldset class="form-group">
                <label for="name">Username</label>
                <input
                  id="name"
                  class="form-control w-100"
                  type="text"
                  title="Please type more than 2 characters."
                  pattern=".{2,}"
                  required
                  v-model="formData['username']"
                  name="username"
                  :disabled="isDisabled"
                />
              </fieldset>
              <TheSellCarFormPhone
                  :value="formData[fields.sellerPhone] || ''"
                  :name="fields.sellerPhone"
                  :disabled="isDisabled"
                />
          </div>
        </div>

        <!-- <div v-if="!collapse" class="d-flex justify-content-end pr-0">
       <CLink 
          @click.prevent="collapse = !collapse" 
          color="primary-ouline"
          class="mb-2 btn-link"
        >
          Show more
        </CLink>
    </div> -->

        <CCollapse :show="collapse" :duration="0">
          <div v-if="collapse" class="form-block mt-2">
            <h2>Vehicle Details</h2>
            <div class="sale-elsewhere">
              <fieldset class="form-group">
                <label for="listed_elsewhere"
                  >Is this car for sale elsewhere?</label
                >
                <div class="custom-radio-container">
                  <div class="form-check">
                    <input
                      id="listed-yes"
                      class="form-check-input"
                      type="radio"
                      value="true"
                      required
                      :checked="isSaleElsewhere"
                      :name="fields.saleElsewhere"
                      @input="onChangeSaleElsewhere"
                      :disabled="isDisabled"
                    />
                    <label class="form-check-label" for="listed-yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input
                      id="listed-no"
                      class="form-check-input"
                      type="radio"
                      value="false"
                      required
                      :checked="!isSaleElsewhere"
                      :name="fields.saleElsewhere"
                      @input="onChangeSaleElsewhere"
                      :disabled="isDisabled"
                    />
                    <label class="form-check-label" for="listed-no">No</label>
                  </div>
                </div>
              </fieldset>

              <template v-if="isSaleElsewhere">
                <p class="note text-danger pb-4">
                  For us to consider your car to list on our platform, all other
                  listings must be taken down
                </p>
              </template>
            </div>

            <div v-show="!isSaleElsewhere">
              <fieldset class="form-group">
                <label for="year">Year</label>
                <select
                  class="form-control"
                  :name="fields.year"
                  v-model="formData[fields.year]"
                  required
                  :disabled="isDisabled"
                >
                  <option
                    v-for="option in selectOptionsMap[fields.year]"
                    :key="option"
                    :value="option"
                    >{{ option }}</option
                  >
                </select>
              </fieldset>
              <div class="d-flex">
                <fieldset class="form-group">
                  <label for="make">Make</label>
                  <input
                    id="make"
                    class="form-control"
                    type="text"
                    title="Please type more than 2 characters."
                    pattern=".{2,}"
                    required
                    v-model="formData[fields.make]"
                    :name="fields.make"
                    :disabled="isDisabled"
                  />
                </fieldset>
                <fieldset class="form-group">
                  <label for="model">Model</label>
                  <input
                    id="model"
                    class="form-control"
                    type="text"
                    title="Please type more than 2 characters."
                    pattern=".{2,}"
                    required
                    v-model="formData[fields.model]"
                    :name="fields.model"
                    :disabled="isDisabled"
                  />
                </fieldset>
              </div>
              <div class="d-flex">
                <fieldset class="form-group">
                  <label for="vin">VIN</label>
                  <input
                    id="vin"
                    class="form-control"
                    type="text"
                    required
                    pattern="[A-Z\d]{17,17}"
                    title="Please type valid VIN code. Vin code is contain 17 digits and symbols in upper case"
                    v-model="formData[fields.vin]"
                    :name="fields.vin"
                    :disabled="isDisabled"
                  />
                  <p v-if="isVinError" class="text-danger">
                    {{ carFormErrorDescription }}
                  </p>
                </fieldset>
                <fieldset class="form-group">
                  <label for="mileage">Mileage (mi)</label
                  ><input
                    id="mileage"
                    v-model="formData.mileage"
                    v-mask="'#######'"
                    type="number"
                    class="form-control"
                    pattern="[\d]+"
                    title="Please type valid mileage."
                    required
                    :name="fields.mileage"
                    :disabled="isDisabled"
                  />
                </fieldset>
              </div>
              <div class="d-flex">
                <fieldset class="form-group">
                  <label for="body_style">Body style</label>
                  <select
                    id="body_style"
                    class="form-control w-100"
                    :name="fields.bodyStyle"
                    v-model="formData[fields.bodyStyle]"
                    required
                    :disabled="isDisabled"
                  >
                    <option
                      v-for="option in selectOptionsMap[fields.bodyStyle]"
                      :key="option"
                      :value="option"
                      >{{ option }}</option
                    >
                  </select>
                </fieldset>
                <fieldset class="form-group">
                  <label for="exteriorColor">Exterior Color</label>
                  <input
                    id="exteriorColor"
                    class="form-control"
                    type="text"
                    required
                    v-model="formData[fields.exteriorColor]"
                    :name="fields.exteriorColor"
                    :disabled="isDisabled"
                  />
                </fieldset>
                <!-- <fieldset class="form-group">
              <label for="transmission">Transmission</label>
              <select
                id="transmission"
                class="form-control w-100"
                :name="fields.transmission"
                v-model="formData[fields.transmission]"
                required
                :disabled="isDisabled"
              >
                <option
                  v-for="option in selectOptionsMap[fields.transmission]"
                  :key="option"
                  :value="option"
                >{{ option }}</option>
              </select>
            </fieldset> -->
                <!-- <fieldset class="form-group">
              <label for="engine">Engine</label>
              <select
                id="engine"
                class="form-control w-100"
                :name="fields.engine"
                v-model="formData[fields.engine]"
                required
                :disabled="isDisabled"
              >
                <option
                  v-for="option in selectOptionsMap[fields.engine]"
                  :key="option"
                  :value="option"
                >{{ option }}</option>
              </select>
            </fieldset> -->
              </div>
              <div class="d-flex">
                <fieldset class="form-group">
                  <label for="drivetrain">Drive Train</label>
                  <select
                    id="drivetrain"
                    class="form-control w-100"
                    :name="fields.drivetrain"
                    v-model="formData[fields.drivetrain]"
                    required
                    :disabled="isDisabled"
                  >
                    <option
                      v-for="option in selectOptionsMap[fields.drivetrain]"
                      :key="option"
                      :value="option"
                      >{{ option }}</option
                    >
                  </select>
                </fieldset>

                <fieldset class="form-group">
                  <label for="interiorColor">Interior Color</label
                  ><input
                    id="interiorColor"
                    type="text"
                    class="form-control"
                    required
                    v-model="formData[fields.interiorColor]"
                    :name="fields.interiorColor"
                    :disabled="isDisabled"
                  />
                </fieldset>
              </div>
              <div class="d-flex">
                <fieldset class="form-group">
                  <label for="modelSpecificTrim">Model Specific Trim</label
                  ><input
                    type="text"
                    class="form-control"
                    id="modelSpecificTrim"
                    v-model="formData[fields.modelSpecificTrim]"
                    :name="fields.modelSpecificTrim"
                  />
                </fieldset>
                <fieldset class="form-group" v-if="formData && formData.type == 't3marketplace'">
                  <label for="price">Price</label
                  ><input
                    type="number"
                    class="form-control"
                    id="price"
                    v-model="formData[fields.price]"
                    name="price"
                  />
                </fieldset>
                <!-- <fieldset class="form-group">
          <label for="battery">Battery</label
          ><input
            type="text"
            class="form-control"
            id="battery"
            required
            v-model="formData[fields.battery]"
            :name="fields.battery"
          />
        </fieldset> -->
              </div>
              <!-- <div class="d-flex">
        <fieldset class="form-group">
          <label for="autopilotSoftware">Autopilot Software</label>
          <select
            id="autopilotSoftware"
            class="form-control w-100"
            :name="fields.autopilotSoftware"
            v-model="formData[fields.autopilotSoftware]"
            required
          >
            <option value="" selected="">Select autopilot software</option>
            <option value="APTP">Autopilot (Tech Package)</option>
            <option value="BA">Base Autopilot (AP)</option>
            <option value="EAP">Enhanced Autopilot (EAP)</option>
            <option value="FSD">Full Self Driving (FSD)</option>
            <option value="NAPHC">No Autopilot (Hardware Capable)</option>
            <option value="NAPNC">No Autopilot (Not Capable)</option>
          </select>
        </fieldset>
        <fieldset class="form-group">
          <label for="autopilotHardware">Autopilot Hardware</label>

          <select
            id="autopilotHardware"
            class="form-control w-100"
            :name="fields.autopilotHardware"
            v-model="formData[fields.autopilotHardware]"
            required
          >
            <option value="" selected="">Select autopilot hardware</option>
            <option value="HW0">0 (HW0)</option>
            <option value="HW1">1.0 (HW1)</option>
            <option value="HW2">2.0 (HW2)</option>
            <option value="HW2.5">2.5 (HW2.5)</option>
            <option value="HW3">3.0 (HW3)</option>
            <option value="HW4">4.0 (HW4)</option>
            <option value="NAP">No Autopilot</option>
          </select>
        </fieldset>
      </div> -->
              <fieldset class="form-group">
                <label for="country">Where is the car located?</label>
                <!-- <div class="custom-radio-container">
              <div class="form-check">
                <input
                  id="country-us"
                  class="form-check-input"
                  type="radio"
                  value="US"
                  required
                  pattern=""
                  :checked="isLocatedUS"
                  :name="fields.country"
                  @input="onChangeCountry"
                  :disabled="isDisabled"
                >
                <label
                  class="form-check-label"
                  for="country-us"
                >United States</label>
              </div>
              <div class="form-check">
                <input
                  id="country-ca"
                  class="form-check-input"
                  type="radio"
                  value="CA"
                  required
                  :checked="isLocatedCA"
                  :name="fields.country"
                  @input="onChangeCountry"
                  :disabled="isDisabled"
                >
                <label
                  class="form-check-label"
                  for="country-ca"
                >Canada</label>
              </div>
            </div> -->
              </fieldset>

              <fieldset class="form-group">
                <label for="zip_code">Zip code</label>
                <input
                  id="zip_code"
                  v-model="formData.zipCode"
                  v-mask="'#####'"
                  class="form-control"
                  type="number"
                  pattern="\d{5,5}"
                  title="Please type valid zip code. Valid zip code is contain 5 numbers."
                  required
                  :name="fields.zipCode"
                  :disabled="isDisabled"
                />
                <p v-if="isLocationZipCodeError" class="text-danger">
                  {{ carFormErrorDescription }}
                </p>
              </fieldset>

              <fieldset v-if="isLocatedCA" class="form-group">
                <label for="city_and_province">City</label>
                <input
                  id="city_and_province"
                  class="form-control"
                  type="text"
                  pattern=".*"
                  placeholder="City"
                  title="Please type city and province. E.g 'Toronto'"
                  required
                  :value="carData[fields.cityAndProvince]"
                  :name="fields.cityAndProvince"
                  :disabled="isDisabled"
                />
                <p v-if="isLocationCityError" class="text-danger">
                  {{ carFormErrorDescription }}
                </p>
              </fieldset>

              <fieldset class="form-group textarea sell-editor">
                <label for="highlights">Tell Us About Your EV</label>
                <TinymceEditor :value="highlights" @input="highlights = $event" />
                <!-- <vue-editor
                  name="highlights"
                  :disabled="isDisabled"
                  :editor="editor"
                  v-model="highlights"
                  :config="editorConfig"
                  aria-placeholder="Please type here..."
                  :editorOptions="editorOptions"
                /> -->

                <!-- <ckeditor
                  name="highlights"
                  :disabled="isDisabled"
                  :editor="editor"
                  v-model="highlights"
                  :config="editorConfig"
                  aria-placeholder="Please type here..."
                >
                </ckeditor> -->

                <!-- <textarea
              id="highlights"
              class="form-control"
              required
              v-model="formData[fields.highlights]"
              :name="fields.highlights"
              :disabled="isDisabled"
            /> -->
              </fieldset>

              <!-- <fieldset class="form-group textarea">
            <label for="knownFlaws">Noteworthy Options/Features</label><textarea
              id="knownFlaws"
              class="form-control"
              required
              :value="carData[fields.knownFlaws]"
              :name="fields.knownFlaws"
            />
          </fieldset> -->

              <fieldset class="form-group textarea">
                <label for="recentServiceHistory"
                  >Do the windshield, windows or mirrors have any chips, cracks
                  or heavy scratches?</label
                ><textarea
                  id="recentServiceHistory"
                  class="form-control"
                  required
                  v-model="formData[fields.recentServiceHistory]"
                  :name="fields.recentServiceHistory"
                  :disabled="isDisabled"
                />
              </fieldset>

              <fieldset class="form-group textarea">
                <label for="equipment"
                  >Is there any damage or cosmetic flaws to the body/paint or
                  interior?</label
                >
                <textarea
                  id="equipment"
                  class="form-control"
                  required
                  v-model="formData[fields.equipment]"
                  :name="fields.equipment"
                  :disabled="isDisabled"
                />
              </fieldset>

              <fieldset class="form-group textarea">
                <label for="sellerNotes"
                  >What is the condition of your tires (mismatch, flat, worn)?
                  Are there any issues with the wheels (curb rash or
                  damage)?</label
                ><textarea
                  id="sellerNotes"
                  class="form-control"
                  v-model="formData[fields.sellerNotes]"
                  :name="fields.sellerNotes"
                  :disabled="isDisabled"
                />
              </fieldset>

              <!-- <fieldset class="form-group">
            <label for="vehicle_stock">Has it been modified?</label>
            <div class="custom-radio-container">
              <div class="form-check">
                <input
                  id="stock-yes"
                  class="form-check-input"
                  type="radio"
                  value="stock"
                  :checked="!isModifiedStock"
                  :name="fields.vehicleStock"
                  @input="onChangeStock"
                  :disabled="isDisabled"
                >
                <label
                  class="form-check-label"
                  for="stock-yes"
                >Completely stock</label>
              </div>
              <div class="form-check">
                <input
                  id="stock-no"
                  class="form-check-input"
                  type="radio"
                  value="modified"
                  :checked="isModifiedStock"
                  :name="fields.vehicleStock"
                  @input="onChangeStock"
                  :disabled="isDisabled"
                ><label
                  class="form-check-label"
                  for="stock-no"
                >Modified</label>
              </div>
            </div>
          </fieldset>

          <fieldset
            v-if="isModifiedStock"
            class="form-group textarea "
          >
            <label for="modifications">What has been modified on the vehicle?</label>
            <textarea
              id="modifications"
              class="form-control"
              required
              v-model="formData[fields.modifications]"
              :name="fields.modifications"
              :disabled="isDisabled"
            />
          </fieldset> -->
            </div>
          </div>
          <div class="form-block">
            <h2>Title Info</h2>
            <fieldset class="form-group">
              <label for="title_country">Where is the vehicle titled?</label
              ><small
                >Note: We require a US title or Canadian registration for the
                vehicle to be considered.</small
              >
              <!-- <div class="custom-radio-container">
              <div class="form-check">
                <input
                  id="title_country-us"
                  class="form-check-input"
                  type="radio"
                  value="US"
                  :checked="isTitledUS"
                  :name="fields.titleCountry"
                  :disabled="isDisabled"
                  required
                  @input="onChangeTitleLocation"
                >
                <label
                  class="form-check-label"
                  for="title_country-us"
                >United States</label>
              </div>
              <div class="form-check">
                <input
                  id="title_country-ca"
                  class="form-check-input"
                  type="radio"
                  value="CA"
                  :checked="isTitledCA"
                  :name="fields.titleCountry"
                  required
                  @input="onChangeTitleLocation"
                  :disabled="isDisabled"
                >
                <label
                  class="form-check-label"
                  for="title_country-ca"
                >Canada</label>
              </div>
            </div> -->
            </fieldset>

            <fieldset v-if="isTitledUS" class="form-group ">
              <label for="title_state">State</label>
              <select
                class="form-control"
                :name="fields.titleState"
                v-model="formData[fields.titleState]"
                required
                :disabled="isDisabled"
              >
                <option
                  v-for="option in selectOptionsMap[fields.titleState]"
                  :key="option"
                  :value="option"
                  >{{ option }}</option
                >
              </select>
            </fieldset>

            <fieldset v-if="isTitledCA" class="form-group ">
              <label for="title_province">Province</label>
              <input
                id="title_province"
                class="form-control"
                type="text"
                required
                v-model="formData[fields.titleProvince]"
                :name="fields.titleProvince"
                :disabled="isDisabled"
              />
            </fieldset>

            <fieldset class="form-group">
              <label for="owner_has_title"
                >Is the vehicle titled in your name?</label
              >
              <div class="custom-radio-container">
                <div class="form-check">
                  <input
                    id="title-yes"
                    class="form-check-input"
                    type="radio"
                    value="true"
                    :checked="!isNotTitledOnSeller"
                    :name="fields.ownerHasTitle"
                    required
                    @input="onChangeTitledOnSeller"
                    :disabled="isDisabled"
                  /><label class="form-check-label" for="title-yes">Yes</label>
                </div>
                <div class="form-check">
                  <input
                    id="title-no"
                    class="form-check-input"
                    type="radio"
                    value="false"
                    :checked="isNotTitledOnSeller"
                    :name="fields.ownerHasTitle"
                    required
                    @input="onChangeTitledOnSeller"
                    :disabled="isDisabled"
                  /><label class="form-check-label" for="title-no">No</label>
                </div>
              </div>
            </fieldset>

            <fieldset v-if="isNotTitledOnSeller" class="form-group ">
              <label for="title_owner">Who’s name is on the title?</label>
              <input
                id="title_owner"
                class="form-control"
                type="text"
                v-model="formData[fields.titleOwner]"
                :name="fields.titleOwner"
                required
                :disabled="isDisabled"
              />
            </fieldset>

            <fieldset class="form-group">
              <label for="title_status">What is the title’s status?</label>
              <select
                class="form-control"
                :name="fields.titleStatus"
                v-model="formData[fields.titleStatus]"
                required
                :disabled="isDisabled"
              >
                <option
                  v-for="option in selectOptionsMap[fields.titleStatus]"
                  :key="option"
                  :value="option.toLowerCase()"
                  >{{ option }}</option
                >
              </select>
            </fieldset>

            <fieldset class="form-group">
              <label for="isPayOff">Is there a payoff?</label>
              <div class="custom-radio-container">
                <div class="form-check">
                  <input
                    id="isPayOff-yes"
                    class="form-check-input"
                    type="radio"
                    value="true"
                    v-model="isPayOff"
                    name="isPayOff"
                    required
                    @input="onChangePayoff"
                  /><label class="form-check-label" for="isPayOff-yes"
                    >Yes</label
                  >
                </div>
                <div class="form-check">
                  <input
                    id="isPayOff-no"
                    class="form-check-input"
                    type="radio"
                    value="false"
                    v-model="isPayOff"
                    name="isPayOff"
                    required
                    @input="onChangePayoff"
                    :disabled="isDisabled"
                  /><label class="form-check-label" for="isPayOff-no">No</label>
                </div>
              </div>
            </fieldset>

            <fieldset
              v-if="isPayOff || isPayOff === 'true'"
              class="form-group "
            >
              <label for="payOffAmount"
                >What is the amount of the payoff?</label
              >
              <input
                class="form-control"
                type="number"
                id="payOffAmount"
                v-model="formData[fields.payOffAmount]"
                :name="fields.payOffAmount"
                required
              />
            </fieldset>

            <fieldset v-if="isPayOff || isPayOff === 'true'" class="form-group">
              <label for="payOffBank">What bank is the loan with?</label>
              <input
                class="form-control w-100"
                type="text"
                id="payOffBank"
                :name="fields.payOffBank"
                v-model="formData[fields.payOffBank]"
                required
              />
            </fieldset>
          </div>
          <div class="form-block mb-3" v-if="formData['type'] != 'sellItForMe'">
            <h2>Minimum Price</h2>
            <!-- <fieldset class="form-group">
              <label for="has_reserve"
                >Do you want to set a minimum price required for your vehicle to
                sell?</label
              >
              <div class="custom-radio-container">
                <div class="form-check">
                  <input
                    id="res-yes"
                    class="form-check-input"
                    type="radio"
                    value="true"
                    :checked="isReservePrice"
                    :name="fields.reserve"
                    required
                    @input="onChangeIsReservePrice"
                    :disabled="isDisabled"
                  /><label class="form-check-label" for="res-yes">Yes</label>
                </div>
                <div class="form-check">
                  <input
                    id="res-no"
                    class="form-check-input"
                    type="radio"
                    value="false"
                    :checked="!isReservePrice"
                    :name="fields.reserve"
                    required
                    @input="onChangeIsReservePrice"
                    :disabled="isDisabled"
                  /><label class="form-check-label" for="res-no">No</label>
                </div>
              </div>
            </fieldset> -->

            <fieldset v-if="isReservePrice" class="form-group">
              <label for="reserve"
                >What minimum price would you like?</label
              >
              <input
                id="reserve"
                type="number"
                class="form-control"
                required
                v-model="formData[fields.reserveValue]"
                :name="fields.reserveValue"
                :disabled="isDisabled"
              />
            </fieldset>
          </div>
          <div
            class="form-block mb-3"
            v-if="formData['type'] === 'sellItForMe'"
          >
            <h2>Minimum Price</h2>
            <fieldset class="form-group">
              <label for="reserve">What minimum price would you like?</label>
              <input
                id="reserve"
                type="number"
                class="form-control"
                required
                v-model="formData[fields.reserveValue]"
                :name="fields.reserveValue"
              />
            </fieldset>
          </div>
          <div
            class="form-block mb-3"
            v-if="currentRouteName === 'AuctionManagement'"
          >
            <h2>Sold After Auction</h2>
            <fieldset class="form-group">
              <label for="has_reserve"
                >Mark this vehicle as Sold After Auction?</label
              >
              <div class="custom-radio-container">
                <div class="form-check">
                  <input
                    id="sold-after-auction-yes"
                    class="form-check-input"
                    type="radio"
                    value="true"
                    :checked="isSoldAfterAuction"
                    :name="fields.isSoldAfterAuction"
                    required
                    @input="onChangeIsSoldAfterAuction"
                    :disabled="isDisabled"
                  /><label class="form-check-label" for="sold-after-auction-yes"
                    >Yes</label
                  >
                </div>
                <div class="form-check">
                  <input
                    id="sold-after-auction-no"
                    class="form-check-input"
                    type="radio"
                    value="false"
                    :checked="!isSoldAfterAuction"
                    :name="fields.isSoldAfterAuction"
                    required
                    @input="onChangeIsSoldAfterAuction"
                    :disabled="isDisabled"
                  /><label class="form-check-label" for="sold-after-auction-no"
                    >No</label
                  >
                </div>
              </div>
            </fieldset>

            <fieldset v-if="isSoldAfterAuction" class="form-group">
              <label for="isSoldAfterAuction"
                >What price did this vehicle sell for?</label
              >
              <input
                id="isSoldAfterAuction"
                type="number"
                class="form-control"
                required
                v-model="formData[fields.soldAfterAuctionValue]"
                name="soldAfterAuctionValue"
                :disabled="isDisabled"
              />
            </fieldset>

            <p v-if="isAfterAuctionError" class="text-danger">
              {{ carFormErrorDescription }}
            </p>
          </div>
          <div>
            <div class="form-block photos">
              <!-- <p>
            Please upload Vehicle History Report.
          </p> -->

              <h2 class="mb-2">
                Upload AutoCheck Report
              </h2>

              <VPdfInput
                ref="pdfInput"
                v-if="collapse"
                :loaded-photos="[{ url: carData.historyReport }]"
                :carId="carData.id"
                :name="fields.historyReport"
                v-model="pdfInputValue"
                :min-count="1"
                @input="onInputPhotos"
                :disabled="false"
              />
            </div>
          </div>
          <div>
            <div
              v-for="(illustrationsImage, index) in illustrationsImagesIds"
              :key="index"
            >
              <h2>{{ illustrationsImage.title }}</h2>
              <div class="row">
                <div
                  class="col-xs-6 col-sm-6 col-md-4 col-lg-3 mb-4"
                  v-for="(illustrationsImageId,
                  index) in illustrationsImage.data"
                  :key="index"
                >
                  <VIllustrationImage
                    ref="photoInput1"
                    :name="fields.carImagesExterior"
                    :min-count="minPhotoCount"
                    @input="onInputPhotos"
                    @onUpdateMainImage="onUpdateMainImage"
                    :id="illustrationsImageId.id"
                    :carId="car.id"
                    :number="illustrationsImageId.number"
                    :isShowNumber="illustrationsImageId.isShowNumber"
                    :imageType="illustrationsImageId.type"
                    :images="images"
                    :imageIds="imageIds"
                    :qrValue="qrValue"
                    :uploadedImages="uploadedImages"
                  />
                </div>
              </div>
              <p
                v-if="illustrationsImage.isErrorShow"
                ref="errorText"
                class="text-danger mb-2"
                tabindex="0"
              >
                {{
                  illustrationsImage.id === 1
                    ? exteriorPhotosErrorMsg
                    : interiorPhotosErrorMsg
                }}
              </p>
            </div>
            <div>
              <h2>Additional Photos</h2>

              <Images
                ref="additionalPhotos"
                name="carImagesOther"
                @input="onInputPhotos"
                :carId="car.id"
                imageType="carImagesOther"
                :uploadedImages="otherImages"
                :images="images"
              />
            </div>
            <!-- <div class="form-block photos">
          <h2 class="mb-2">
            Mechanical photos
          </h2>

          <VPhotoInput
            ref="photoInput3"
            v-if="collapse"
            :loaded-photos="mechanicalPhotos"
            :name="fields.carImagesMechanical"
            :min-count="1"
            @input="onInputPhotos"
            :disabled="isDisabled"
          />
        </div> -->
            <!-- <div class="form-block photos">
          <h2 class="mb-2">
            Other photos
          </h2>

          <VPhotoInput
            ref="photoInput5"
            v-if="collapse"
            :loaded-photos="otherPhotos"
            :name="fields.carImagesOther"
            :min-count="1"
            @input="onInputPhotos"
            :disabled="isDisabled"
          />
        </div> -->
            <!-- <div class="form-block photos">
          <h2 class="mb-2">
            Other Photos & Docs
          </h2>

          <VPhotoInput
            ref="photoInput4"
            v-if="collapse"
            :loaded-photos="docsPhotos"
            :name="fields.carImagesDocs"
            :min-count="0"
            @input="onInputPhotos"
            :disabled="isDisabled"
          />
          <p class="mt-2 mb-0 font-italic">service records, car fax report, etc.</p>
        </div> -->

            <div class="form-block photos">
              <h2 class="mb-2">
                Videos
              </h2>

              <div class="input-expander pb-0">
                <fieldset class="form-group ">
                  <label for="current_listings-input-0"
                    >Please link to all existing videos</label
                  >
                  <input
                    id="current_listings-input-0"
                    class="form-control"
                    type="text"
                    pattern="https:\/\/.+"
                    title="Please type valid link. Start with https://"
                    :name="fields.videos"
                    :disabled="isDisabled"
                  />
                </fieldset>
                <template v-if="videos > 0">
                  <fieldset
                    v-for="(item, idx) in carDataVideos"
                    :key="idx"
                    class="form-group"
                  >
                    <input
                      class="form-control"
                      type="text"
                      pattern="https:\/\/.+"
                      title="Please type valid link. Start with https://"
                      :value="item.url"
                      :name="fields.videos"
                      :disabled="isDisabled"
                    />
                  </fieldset>
                </template>
                <button
                  class="btn btn-link"
                  type="button"
                  @click="addVideos"
                  :disabled="isDisabled"
                >
                  + Add more
                </button>
              </div>
            </div>
          </div>
        </CCollapse>

        <!-- <button 
      v-if="this.currentRouteName === 'draftVehicleManager'"
      type="submit" 
      class="btn btn-primary btn-lg  d-block ml-auto mr-auto"
      :class="{ disabled: sendingCar || isSaleElsewhere }"
      :disabled="sendingCar || isSaleElsewhere || isDisabled"
    >
      <CSpinner v-if="sendingCar" size="3xl" color="white" class="mr-3" />
      <span>{{ sendingCar ? 'Submitting...' : 'Submit Vehicle' }} </span>
    </button>   -->
        <button
          type="submit"
          class="btn btn-primary btn-lg submit d-block ml-auto mr-auto"
          :class="{ disabled: sendingCar || isSaleElsewhere }"
          :disabled="sendingCar || isSaleElsewhere || isDisabled"
        >
          <CSpinner v-if="sendingCar" size="3xl" color="white" class="mr-3" />
          <span>{{ sendingCar ? "Saving..." : "Save" }} </span>
        </button>
        <!-- <CLink class="car-form__to-top-link" v-if="collapse" @click.prevent="toTop">To top</CLink> -->
      </form>
    </div>
    <div v-if="loading">
      <LoaderComponent />
    </div>
  </div>
</template>
<script>
import {
  createCarManagerMixin,
  carManagerStore
} from "@/mixins/carManagerMixin";
import VPhotoInput from "./VPhotoInput";
import TheSellCarFormPhone from "./TheSellCarFormPhone";
import * as inputErrorHandler from "@/utils/validation/inputErrorHandler";
import { parseCarToForm } from "@/utils/validation/car";
import {
  carFormFields,
  carFormFieldValues,
  MIN_PHOTO_COUNT,
  yearOptions,
  bodyStyleOptions,
  engineOptions,
  transmissionOptions,
  drivetrainOptions,
  stateOptions,
  titleStatusOptions
} from "@/utils/dictionaries/carForm";
import VIllustrationImage from "./VIllustrationImage";
import ImageTypes from "@/utils/dictionaries/imageTypes";
import LoaderComponent from "@/components/LoaderComponent.vue";
import {
  createAuctionManagerMixin,
  auctionManagerStore
} from "@/mixins/auctionsManagerMixin";
import VPdfInput from "./VPdfInput";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import { VueEditor, Quill } from "vue2-editor";
import TinymceEditor from "@/components/TinymceEditor.vue";
import Images from "@/components/Images.vue";
// const Font = Quill.import("formats/font");
// Font.whitelist = ["small", "normal", "large", "huge"];
// Quill.register(Font, true);
// const Size = Quill.import("attributors/style/size");
// Size.whitelist = ["10px", "12px", "16px", "18px", "24px", "32px"];
// Quill.register(Size, true);
// const Color = Quill.import("attributors/style/color");
// Quill.register(Color, true);
// const Link = Quill.import("formats/link");
// Link.sanitize = function(url) {
//   const value = url;
//   if (value.startsWith("http")) {
//     return value;
//   } else {
//     return `https://${value}`;
//   }
// };
// // import localStorage from '@/utils/localStorage';
// const toolbarOptions = [
// [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
//   ["bold", "italic", "underline", "strike"], // Basic formatting
//   [
//     {
//       size: [
//         "8px",
//         "9px",
//         "10px",
//         "12px",
//         "14px",
//         "16px",
//         "20px",
//         "24px",
//         "32px",
//         "42px",
//         "54px",
//         "68px",
//         "84px",
//         "98px",
//       ],
//     },
//   ], // Custom sizes
//   [{ color: [] }, { background: [] }], // Font and background colors
//   [{ align: [] }], // Text alignment
//   ["link", "image", "video"], // Links, images, and videos
//   ["clean"], // Clear formatting
// ];
// const customModule = {
//   toolbar: toolbarOptions,
//   handlers: {
//     size(value) {
//       // Set the font size
//       if (value) {
//         this.quill.format("size", value);

//         // Find the dropdown and update the label
//         const dropdown = document.querySelector(".ql-size .ql-picker-label");
//         if (dropdown) {
//           dropdown.innerText = value; // Update the dropdown label
//         }
//       }
//     },
//        link: function(value) {
//               if (value) {
//                 const href = prompt("Enter the URL");
//                 if (href) {
//                   const range = this.quill.getSelection();
//                   if (range) {
//                     this.quill.format("link", href);
//                     // Apply target="_blank"
//                     const [link] = this.quill.getLeaf(range.index);
//                     if (link.domNode) {
//                       link.domNode.setAttribute("target", "_blank");
//                     }
//                   }
//                 }
//               } else {
//                 this.quill.format("link", false);
//               }
//             }
//   },
// };
export default {
  name: "TheSellCarForm",

  props: {
    car: {
      type: Object,
      default: () => ({})
    },
    startDate: {
      type: Date,
      default: ""
    },
    endDate: {
      type: Date,
      default: ""
    }
  },
  components: {
    Images,
    TheSellCarFormPhone,
    VIllustrationImage,
    VPdfInput,
    LoaderComponent,
    // VueEditor,
    TinymceEditor
  },

  mixins: [createAuctionManagerMixin(), createCarManagerMixin()],

  data: () => ({
    editorOptions: {
      modules: {
        toolbar: [
[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  ["bold", "italic", "underline", "strike"], // Basic formatting
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'size': ['8px', '10px', '12px', '14px','16px','18px','20px','22px','24px','26px','28px','30px'] }], // Custom sizes
  [{ color: [] }, { background: [] }], // Font and background colors
  [{ align: [] }], // Text alignment
  ["link", "image", "video"], // Links, images, and videos
  ["clean"], // Clear formatting
]
      }
    },
    errorType: null,
    errorMessage: null,
    currentRouteName: null,
    loading: true,
    imageIds: [],
    collapse: true,
    isDealer: false,
    isSaleElsewhere: false,
    isLocatedUS: true,
    isLocatedCA: false,
    isTitledUS: true,
    isTitledCA: false,
    isPayOff: false,
    isModifiedStock: false,
    isNotTitledOnSeller: false,
    isReservePrice: true,
    isSoldAfterAuction: false,
    highlights: "",
    otherItemsIncludedInSale: 0,
    videos: 0,
    fields: { ...carFormFields },
    minPhotoCount: MIN_PHOTO_COUNT,
    carFormError: null,
    exteriorPhotosErrorMsg: `Upload at least ${MIN_PHOTO_COUNT} photos of the vehicle’s exterior`,
    interiorPhotosErrorMsg: `Upload at least 6 photos of the vehicle’s interior`,

    sendingCar: false,
    pdfInputValue: null,
    formData: {
      sellerPhone: "",
      mileage: "",
      zipCode: ""
    },
    uploadedImages: [],
    images: [],
    illustrationsImagesIds: [
      {
        id: 1,
        title: "Exterior",
        isErrorShow: false,
        data: [
          {
            id: 1,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 2,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 3,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 4,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 5,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 6,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 7,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 8,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          // {
          //   id: 9,
          //   number: null,
          //   isShowNumber: false,
          //   type: "carImagesExterior"
          // },
          // {
          //   id: 10,
          //   number: null,
          //   isShowNumber: false,
          //   type: "carImagesExterior"
          // },
          // {
          //   id: 11,
          //   number: null,
          //   isShowNumber: false,
          //   type: "carImagesExterior"
          // },
          // {
          //   id: 12,
          //   number: null,
          //   isShowNumber: false,
          //   type: "carImagesExterior"
          // },
          { id: 13, number: 1, isShowNumber: true, type: "carImagesExterior" },
          { id: 14, number: 2, isShowNumber: true, type: "carImagesExterior" },
          { id: 15, number: 3, isShowNumber: true, type: "carImagesExterior" },
          { id: 16, number: 4, isShowNumber: true, type: "carImagesExterior" },
          {
            id: 17,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 18,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 19,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 20,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 21,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 22,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 23,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 24,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          },
          {
            id: 25,
            number: null,
            isShowNumber: false,
            type: "carImagesExterior"
          }
        ]
      },
      {
        id: 2,
        title: "Interior",
        isErrorShow: false,
        data: [
          {
            id: 26,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 27,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 28,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 29,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 30,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 31,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 32,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 33,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 34,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 35,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 36,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          },
          {
            id: 37,
            number: null,
            isShowNumber: false,
            type: "carImagesInterior"
          }
        ]
      }
    ],
    qrValue: "local",
    editor: ClassicEditor,
    editorConfig: {
      // extraPlugins: [ MyCustomUploadAdapterPlugin ],
      // The configuration of the editor.
      // extraPlugins: 'youtube'
      ckfinder: {
        // The URL that the images are uploaded to.
        uploadUrl: "/uploads",
        // Enable the XMLHttpRequest.withCredentials property.
        // withCredentials: true,

        // Headers sent along with the XMLHttpRequest to the upload server.
        headers: {
          // "X-CSRF-TOKEN": "CSFR-Token",
          Authorization: `${localStorage.getItem("auth._token.local")}`
        }
      }
    }
  }),

  computed: {
    otherImages() {
      return this.uploadedImages.filter(img => img.type === 5);
    },
    isAfterAuctionError() {
      return inputErrorHandler.isAfterAuctionError(this.carFormError);
    },
    isLocationZipCodeError() {
      return inputErrorHandler.isLocationZipCodeError(this.carFormError);
    },
    isLocationCityError() {
      return inputErrorHandler.isLocationCityError(this.carFormError);
    },
    isVinError() {
      return inputErrorHandler.isVINError(this.carFormError);
    },
    carFormErrorDescription() {
      return inputErrorHandler.getErrorDescription(this.carFormError);
    },
    carImages() {
      return this[carManagerStore.getterTypes.GETTER_CAR];
    },
    carData() {
      return this[carManagerStore.getterTypes.GETTER_CAR];
    },
    selectOptionsMap() {
      return {
        [carFormFields.year]: yearOptions,
        [carFormFields.bodyStyle]: bodyStyleOptions,
        [carFormFields.engine]: engineOptions,
        [carFormFields.transmission]: transmissionOptions,
        [carFormFields.drivetrain]: drivetrainOptions,
        [carFormFields.titleState]: stateOptions,
        [carFormFields.titleStatus]: titleStatusOptions
      };
    },
    exteriorPhotos() {
      if (!this.carData.carImages) return;
      return this.carData.carImages.filter(
        image => image.type === ImageTypes.Exterior
      );
    },
    interiorPhotos() {
      if (!this.carData.carImages) return;
      return this.carData.carImages.filter(
        image => image.type === ImageTypes.Interior
      );
    },
    mechanicalPhotos() {
      if (!this.carData.carImages) return;
      return this.carData.carImages.filter(
        image => image.type === ImageTypes.Mechanical
      );
    },
    docsPhotos() {
      if (!this.carData.carImages) return;
      return this.carData.carImages.filter(
        image => image.type === ImageTypes.Docs
      );
    },
    otherPhotos() {
      if (!this.carData.carImages) return;
      return this.carData.carImages.filter(
        image => image.type === ImageTypes.Other
      );
    },
    carDataVideos() {
      const result = [];
      for (let index = 0; index < this.videos; index++) {
        result.push(
          this.carData?.carVideos[index]
            ? this.carData?.carVideos[index]
            : { url: "" }
        );
      }

      return result;
    },
    isDisabled() {
      return this.carData.disabled;
    }
  },

  watch: {
    highlights(newVal) {
      console.log("Updated content from editor:", newVal);
    },
    pdfInputValue(newValue) {
      debugger;
      this.updateFieldsHistoryReport(newValue);
    },
    isAfterAuctionError(v) {
      if (v) {
        this.focusToInputByName(carFormFields.soldAfterAuctionValue);
      }
    },
    isLocationZipCodeError(v) {
      if (v) {
        this.focusToInputByName(carFormFields.zipCode);
      }
    },
    isLocationCityError(v) {
      if (v) {
        this.focusToInputByName(carFormFields.cityAndProvince);
      }
    },
    isVinError(v) {
      if (v) {
        this.focusToInputByName(carFormFields.vin);
      }
    }
  },
  mounted() {
    this.currentRouteName = this.$route.name;
  },
  created() {
    this.getDateById();

    this[auctionManagerStore.mutationTypes.MUTATION_UNSET_CAR_FORM_IMAGES]();
  },

  methods: {
    onChangePayoff(e) {
      // this.isPayOff = this.getCarFormData().get("isPayOff") === "false";
      this.isPayOff = e.target.value === "true";
    },
    async getDateById() {
      try {
        this.loading = true;
        await this[carManagerStore.actionTypes.ACTION_LOAD_CAR_BY_ID]({
          id: this.car.uuid
        });
        this.setInitialData();
        this.loading = false;
      } catch (errorMessage) {
        this.loading = false;
        console.log(errorMessage);
      }
    },
    reloadRoute() {
      // Get the current route
      const currentRoute = this.$route;

      try {
        // Use $router.push to navigate to the same route
        this.$router
          .push({
            path: currentRoute.path,
            params: currentRoute.params,
            query: currentRoute.query
          })
          .catch(() => {});
      } catch (error) {
        // Handle the NavigationDuplicated error (optional)
        console.warn("NavigationDuplicated error caught:", error.message);
      }
    },
    toTop() {
      const modal = document.querySelector(`[role="dialog"].modal`);
      if (modal) {
        modal.scrollTop = 0;
      }
    },

    updateFieldsHistoryReport(value) {
      this.fields.historyReport = value;
    },
    getCarVideoUrl(index) {
      return this.carDataVideos;
    },

    setInitialData() {
      this.isDealer =
        this.carData[carFormFields.sellerType] ===
        carFormFieldValues.sellerType_Dealer;
      this.isLocatedUS =
        this.carData[carFormFields.location]?.country ===
        carFormFieldValues.location_US;
      this.isLocatedCA =
        this.carData[carFormFields.location]?.country ===
        carFormFieldValues.location_CA;
      this.isTitledUS =
        this.carData[carFormFields.titleCountry] ===
        carFormFieldValues.titled_US;
      this.isTitledCA =
        this.carData[carFormFields.titleCountry] ===
        carFormFieldValues.titled_CA;
      this.isModifiedStock =
        this.carData[carFormFields.modifications]?.length > 0;
      this.isReservePrice = Boolean(this.carData[carFormFields.reserve]);
      this.isSoldAfterAuction = Boolean(
        this.carData[carFormFields.isSoldAfterAuction]
      );
      this.soldAfterAuctionValue =
        this.carData[carFormFields.soldAfterAuctionValue] === null
          ? ""
          : this.carData[carFormFields.soldAfterAuctionValue];
      this.videos = this.carData?.carVideos?.length;
      this.uploadedImages = this.carData.carImages;
      this.highlights = this.carData.highlights;
      this.isPayOff = this.carData.payOffAmount ? true : false;
      const data = localStorage.getItem("auth._token.local");
      this.fields.historyReport = this.carData.historyReport;
      this.pdfInputValue = this.carData.historyReport;
      this.qrValue = `${process.env.VUE_APP_FRONTEND_URL}/code?data=${btoa(
        data
      )}&&uuid=${btoa(this.carData.uuid)}`;
      this.formData = {
        price: this.carData.feeAmount,
        firstName: this.carData.owner["firstName"],
        sellerPhone: this.carData[carFormFields.sellerPhone],
        lastName: this.carData.owner["lastName"],
        mileage: this.carData[carFormFields.mileage],
        zipCode: this.carData[carFormFields.location]?.zipCode,
        username: this.carData["owner"]?.username,
        ...this.carData
      };
      console.log("formData",this.formData)
      console.log("this.formData", this.formData);
    },

    focusToInputByName(name) {
      const input =
        this.$refs.carForm &&
        this.$refs.carForm.querySelector(`input[name="${name}"]`);
      input && input.focus();
    },

    checkPhotoInputComponentValidity(number) {
      const component = this.$refs[`photoInput${number}`];
      return component && component.hasErrors();
    },

    checkPhotoInputComponentReady(number) {
      const component = this.$refs[`photoInput${number}`];
      return component && component.hasLoadingPhotos();
    },

    async onSubmitCarForm() {
      // const hasPhotoInputError = this.checkPhotoInputComponentValidity(1) ||
      //   this.checkPhotoInputComponentValidity(2) ||
      //   this.checkPhotoInputComponentValidity(3) ||
      //   this.checkPhotoInputComponentValidity(4) ||
      //   this.checkPhotoInputComponentValidity(5)

      // const hasLoadingPhotos = this.checkPhotoInputComponentReady(1) ||
      //   this.checkPhotoInputComponentReady(2) ||
      //   this.checkPhotoInputComponentReady(3) ||
      //   this.checkPhotoInputComponentReady(4) ||
      //   this.checkPhotoInputComponentReady(5)

      // if (hasLoadingPhotos) {
      //   this.$modals.open({
      //     header: 'Uploading car photos',
      //     body: 'Please wait to uploading your car photos and try again.'
      //   })

      //   return
      // }

      if (!this.$refs.carForm.checkValidity()) return;
      this.sendCarForm();
    },

    async sendCarForm() {
      this.carFormError = null;
      this.sendingCar = true;

      try {
        if (this.images && this.images.length > 0) {
          let carImagesExterior = this.images.filter(
            x => x.type === "carImagesExterior"
          );
          let carImagesInterior = this.images.filter(
            x => x.type === "carImagesInterior"
          );
          let exteriorData = this.illustrationsImagesIds[0].data;
          let interiorData = this.illustrationsImagesIds[1].data;
          if (
            carImagesExterior.length >= exteriorData.length &&
            carImagesInterior.length >= interiorData.length &&
            this.currentRouteName === "draftVehicleManager"
          ) {
            const formData = this.getCarFormData();
            formData.append("isPublished", true);
            if (this.endDate) {
              formData.append("endDate", this.endDate);
            }
            if (this.startDate) {
              formData.append("startDate", this.startDate);
            }
            formData.append("highlights", this.highlights);
            if (this.formData["type"] === "sellItForMe") {
              formData.append("reserve", true);
            }
            if (this.formData["type"] === "sellYourEv") {
              formData.append("reserve", true);
            }
            if (this.formData["type"] === "t3marketplace") {
              formData.append("reserve", true);
            }

            await this[
              auctionManagerStore.actionTypes.ACTION_PUBLISH_AUCTION_CAR
            ]({ carId: this.car.id, formData: formData });
          } else {
            const formData = this.getCarFormData();
            formData.append("highlights", this.highlights);
            if (this.endDate) {
              formData.append("endDate", this.endDate);
            }
            if (this.startDate) {
              formData.append("startDate", this.startDate);
            }
            if (this.formData["type"] === "sellItForMe") {
              formData.append("reserve", true);
            }
            if (this.formData["type"] === "sellYourEv") {
              formData.append("reserve", true);
            }
            if (this.formData["type"] === "t3marketplace") {
              formData.append("reserve", true);
            }
            await this[
              auctionManagerStore.actionTypes.ACTION_UPDATE_AUCTION_CAR
            ]({ carId: this.car.id, formData: formData });
          }
        } else {
          const formData = this.getCarFormData();
          if (this.endDate) {
            formData.append("endDate", this.endDate);
          }
          if (this.startDate) {
            formData.append("startDate", this.startDate);
          }
          if (this.formData["type"] === "sellItForMe") {
            formData.append("reserve", true);
          }
          if (this.formData["type"] === "sellYourEv") {
              formData.append("reserve", true);
            }
          if (this.formData["type"] === "t3marketplace") {
              formData.append("reserve", true);
            }
          await this[
            auctionManagerStore.actionTypes.ACTION_UPDATE_AUCTION_CAR
          ]({ carId: this.car.id, formData: formData });
        }
        this.$emit("success");
      } catch (error) {
        this.carFormError = error.response && error.response.data;
      } finally {
        setTimeout(() => {
          this.sendingCar = false;
        }, 500);
      }
    },

    onChangeSellerType() {
      this.isDealer = this.getCarFormData().get("sellerType") === "Dealer";
    },

    onChangeSaleElsewhere() {
      this.isSaleElsewhere =
        this.getCarFormData().get("saleElsewhere") === "true";

      if (this.isSaleElsewhere) {
        this.otherItemsIncludedInSale = 0;
      }
    },

    onChangeCountry() {
      this.isLocatedCA = this.getCarFormData().get("country") === "CA";
      this.isLocatedUS = this.getCarFormData().get("country") === "US";
    },

    onChangeTitleLocation() {
      this.isTitledCA = this.getCarFormData().get("titleCountry") === "CA";
      this.isTitledUS = this.getCarFormData().get("titleCountry") === "US";
    },

    onChangeTitledOnSeller() {
      this.isNotTitledOnSeller =
        this.getCarFormData().get("ownerHasTitle") === "false";
    },

    onChangeStock() {
      this.isModifiedStock =
        this.getCarFormData().get("vehicleStock") === "modified";
    },

    onChangeIsReservePrice() {
      this.isReservePrice = this.getCarFormData().get("reserve") === "true";
    },

    onChangeIsSoldAfterAuction() {
      this.isSoldAfterAuction =
        this.getCarFormData().get("isSoldAfterAuction") === "true";
    },

    onInputPhotos() {
      console.log(this.$refs.photoInput);
    },
    onUpdateMainImage(imgObj) {
      this.uploadedImages.forEach(image => {
        if (image.id === imgObj.result.id) {
          image.mainImage = imgObj.result.mainImage;
        } else {
          image.mainImage = 0;
        }
      });
      this.$forceUpdate();
      this.reloadRoute();
    },

    /**
     * @returns {FormData} formData
     */
    getCarFormData() {
      const formData = new FormData(this.$refs.carForm);
      debugger;
      formData.append("historyReport", this.pdfInputValue);

      return formData;
    },

    addOtherItemsIncludedInSale() {
      this.otherItemsIncludedInSale += 1;
    },

    addVideos() {
      this.videos += 1;
    }
  }
};
</script>
<style>
.car-form__to-top-link {
  position: absolute;
  right: 16px;
}
</style>
<style lang="css">

@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
